<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Change Unpause Date</span>
  <ng-container dialog-content>
    <div>
      <p>Update the date when the game will automatically unpause and resume normal operation.</p>
    </div>
    <form [formGroup]="changeUnpauseDateForm">
      <mat-form-field appearance="outline" class="full-width margin-top-med">
        <mat-label>Unpause Date</mat-label>
        <input
          matInput
          formControlName="unpauseDate"
          class="margin-top-med full-width"
          type="datetime-local"
          id="unpause-date"
          data-testid="change-unpause-date-input"
          name="unpause date"/>
        <mat-hint>Use your local time zone, not the game's time zone.</mat-hint>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary"
            data-testid="change-unpause-date-submit-button"
            (click)="submit()">Update</button>
  </ng-container>
</app-dialog-base>
